import apiClient from '../apiClient';
import { GET_TRANSPORTATION_UNIT_BY_HEADER_ID_URL } from '../apiUrl';

const getTransportationUnitByHeaderIdApi = Id => {
  return apiClient.get(GET_TRANSPORTATION_UNIT_BY_HEADER_ID_URL(Id));
};

export default getTransportationUnitByHeaderIdApi;
